export const REQUEST_SOLUTION = "REQUEST_SOLUTION";
export const RECEIVED_SOLUTION = "RECEIVED_SOLUTION";
export const ERROR_SOLUTION = "ERROR_SOLUTION";

export const SOLUTION_NONE = "SOLUTION_NONE";
export const SOLUTION_REQUESTING = "SOLUTION_REQUESTING";
export const SOLUTION_RECEIVED = "SOLUTION_RECEIVED";
export const SOLUTION_ERROR = "SOLUTION_ERROR";
